<template>
    <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader"/>
      <rule-game :title="ruleTitle.payRate" :value="rulePayrate"/>
      <rule-game :title="ruleTitle.rule" :value="ruleGame"/>
      <rule-game :title="ruleTitle.dealer" :value="ruleDealer"/>
      <rule-game :title="ruleTitle.player" :value="rulePlayer"/>
    </div>
  </div>
</template>

<script>
import Board from '../../assets/gamerule/punpae/B_Head-or-Tail.png';
import punpaePic1 from '../../assets/gamerule/punpae/pp1.png';
import punpaePic2 from '../../assets/gamerule/punpae/pp2.png';
import punpaePic3 from '../../assets/gamerule/punpae/pp3.png';
import punpaePic4 from '../../assets/gamerule/punpae/pp4.png';
import player1 from '../../assets/gamerule/punpae/PLAYER1-min.png';
import player2 from '../../assets/gamerule/punpae/PLAYER2-min.png';
import player3 from '../../assets/gamerule/punpae/PLAYER3-min.png';

export default {
  name: 'rule_punpae',
  data() {
    return {
      ruleHeader: {
        gameName: 'ปั่นแปะ (Punpae)',
        boardImg: Board,
      },
      ruleTitle: {
        payRate: 'อัตราการจ่าย',
        rule: 'กติกา',
        player: 'ผู้เล่น',
      },
      rulePayrate: [
        {
          type: 'text',
          text: 'อัตราจ่าย 1:0.97',
          class: 'ml-3',
        },
        {
          type: 'text',
          text: 'หากผู้เล่นลงเดิมพัน 100 บาท และได้รับชัยชนะ ผู้เล่นจะได้รับเงินจากการเดิมพัน 97 บาท',
          class: 'ml-3',
        },
      ],
      ruleGame: [
        {
          type: 'text',
          text: 'จำนวน ผู้เล่นต่อ 1 ห้อง มีได้ 2-50 คน และจะเริ่มเดิมพัน',
          class: 'ml-3',
        },
        {
          type: 'text',
          text: '',
        },
        {
          type: 'text',
          text: 'วิธีเดิมพันมี 2 ประเภท คือ หัว , ก้อย',
          class: 'ml-3',
        },
        {
          type: 'text',
          text: '1. ผู้เล่นมีเวลา 15 วินาที ในการวางเดิมพัน เมื่อหมดเวลาระบบจะทำการ สุ่มออกผลโดยอัตโนมัติ หากวางเดิมพันหัว แล้วผลออกมาตรงตามที่เดิมพันก็จะได้รับเงินตามจำนวนที่วางเดิมพันไป เช่น วางเดิมพันหัว 500 บาท แล้วผลออกมาเป็น "หัว" ลูกค้าจะได้รับเงิน 500 บาท',
          class: 'ml-3',
        },
        {
          type: 'twoImage',
          image: punpaePic1,
          class: 'w-100',
          image2: punpaePic2,
        },
        {
          type: 'text',
          text: '2. หากวางเดิมพันทั้ง “หัว” และ “ก้อย” ในจำนวนเงินที่เท่ากัน เมื่อผลออกมาก็จะเท่ากับ เสมอ เช่น วางเดิมพัน”หัว” และ “ก้อย” 500 บาท แล้วผลออกมาเป็น จะเท่ากับ เสมอ',
          class: 'ml-3',
        },
        {
          type: 'twoImage',
          image: punpaePic3,
          class: 'w-100',
          image2: punpaePic4,
        },
      ],
      rulePlayer: [
        {
          type: 'text',
          text: 'จำนวน ผู้เล่นต่อ 1 ห้อง มีได้ 2-50 คน และจะเริ่มเดิมพัน',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: player1,
          class: 'w-50',
          text: 'ผู้เล่นสามารถเลือกชิป ในการลงเดิมพันได้เเละถ้าหากจำนวนเงินของผู้เล่นน้อยกว่าชิปจะไม่สามารถทำการเลือกชิปที่มีมูลค่าสูงกว่าได้',
        },
        {
          type: 'imageText',
          image: player2,
          class: 'w-50',
          text: 'การเดิมพันในแต่ละรอบจะอิงจากยอดขั้นต่ำ(Minimum)กับยอดเดิมพัน',
        },
        {
          type: 'imageText',
          image: player3,
          class: 'w-50',
          text: 'สามารถกดปุ่ม ยืนยัน หรือ ยกเลิกได้ ถ้าไม่กดยืนยันถือว่าไม่ได้ทำการเดิมพัน',
        },

      ],
    };
  },
};
</script>

<style lang="css" scoped>
.white-color {
  color: white;
}

.font-big {
  font-size: 1.8vw;
}
</style>
